<template>
  <div class="breadcrumb">
    <a @click="$emit('home')" v-show="showHome">Centro de Ayuda</a>
    <span v-if="showHome">&gt;</span>
    <a @click="$emit('product')" v-show="productShow">{{productActive}}</a>
    <span v-show="menuShow">&gt;</span>
    <a v-show="menuShow">{{menuActive}}</a>
  </div>
</template>

<script>
/**
 * @component HelpCenterBreadcrumb
 * @description Migas de pan del Centro de Ayuda: Centro de Ayuda > producto > tema.
 * @example <help-center-breadcrumb :product-active="name" :product-show="true" @home="goHome" @product="goProduct" />
 */
export default {
  name: 'HelpCenterBreadcrumb',
  props: {
    productActive: {
      type: String,
      default: ''
    },
    menuActive: {
      type: String,
      default: ''
    },
    productShow: {
      type: Boolean,
      default: false
    },
    menuShow: {
      type: Boolean,
      default: false
    },
    showHome: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/help-center/HelpCenterBreadcrumb.vue